import type { CSSProperties } from 'react';
import { useI18nContext } from '@/i18n/i18n-react';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { NotificationPreview } from '@/components/notification-preview';
import { Bell } from 'lucide-react';
import { cn } from '@/lib/utils';

export function CampaignNotificationSection({
  notificationTitle,
  notificationBody,
  notificationLink,
  iconUrl,
  className,
  style,
}: {
  notificationTitle: string;
  notificationBody: string;
  notificationLink: string;
  iconUrl: string | null | undefined;
  className?: string;
  style?: CSSProperties;
}) {
  const { LL } = useI18nContext();

  return (
    <Card
      className={cn('border-secondary border-4 bg-secondary', className)}
      style={style}
    >
      <CardHeader className="p-4 bg-secondary text-secondary-foreground">
        <CardTitle className="flex items-center gap-2 text-base font-medium">
          <Bell data-icon="inline-start" className="size-4" />
          {LL.campaignDetails.notificationDetails()}
        </CardTitle>
        <CardDescription>
          {LL.campaignDetails.notificationDescription()}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4 rounded bg-background p-4">
        <div className="space-y-2">
          <h3 className="text-sm font-medium">
            {LL.campaignDetails.notificationPreview()}
          </h3>
          <NotificationPreview
            title={notificationTitle}
            body={notificationBody}
            iconUrl={iconUrl}
            className="max-w-[50ch]"
          />
        </div>
        <div className="space-y-1">
          <h3 className="text-sm font-medium">{LL.campaignDetails.link()}</h3>
          <p className="text-sm text-muted-foreground">
            {LL.campaignDetails.linkHelp()}
          </p>
          <a
            className="break-all text-primary underline"
            href={notificationLink}
          >
            {notificationLink}
          </a>
        </div>
      </CardContent>
    </Card>
  );
}
